import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";

function AIAgents() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// services"}</span>
          <h1 className="edge-page-title">
            AI <span>Agents</span>
          </h1>
          <p className="edge-page-subtitle">
            Custom AI agents and n8n workflows that automate your most complex
            data pipelines, business processes, and decision loops — built to
            run reliably at scale.
          </p>
          <Link to="/contact" className="ep-btn-primary">
            Start a Project →
          </Link>
        </Container>
      </section>

      <section className="edge-page-body">
        <Container>
          <div className="edge-stub-card">
            <div className="edge-stub-icon">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
              </svg>
            </div>
            <h3>Full case studies coming soon</h3>
            <p>
              We're documenting our AI agent work — from autonomous data ingestion
              pipelines to multi-step reasoning agents. Check back shortly, or
              reach out to talk through your specific use case.
            </p>
            <Link to="/contact" className="ep-btn-primary">
              Talk to us
            </Link>
          </div>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default AIAgents;
